/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';

import { styled } from '@styles/stitches';
import { AlertDialog, Box, Button, Text } from '@versumstudios/ui';

export interface IMaintenance {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
}

const Path = styled('path', {
  fill: '$primaryFill',
});

export const Maintenance: FC<IMaintenance> = ({ open, onOpenChange }) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange} fill opaque canClose={false}>
      <>
        <Box css={{ width: '100%', backgroundColor: '$secondaryBackground' }} horizontal>
          <Box css={{ marginTop: 32, height: 150, overflow: 'hidden' }}>
            <svg width="107" height="101" viewBox="0 0 107 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <Path d="M99.94 21.14C97.9992 17.6977 95.678 14.4843 93.02 11.56L57.74 46.84L93.02 82.14C95.6789 79.1984 98.0001 75.9683 99.94 72.51L74.29 46.8L99.94 21.14Z" />
              <Path d="M27.51 0.0400019C24.0437 1.99874 20.8128 4.34732 17.88 7.04L53.22 42.32L88.5 7.04C85.5753 4.35965 82.3623 2.01196 78.92 0.0400019L53.22 25.75L27.51 0.0400019Z" />
              <Path d="M89.19 40.97L83.34 46.82L89.19 52.68H106.12C106.333 50.7339 106.439 48.7777 106.44 46.82C106.441 44.8656 106.334 42.9126 106.12 40.97H89.19Z" />
              <Path d="M13.41 11.54C4.53287 21.1153 -0.275596 33.7657 5.80214e-07 46.82C-0.121451 53.8262 1.19993 60.7825 3.88196 67.2562C6.56398 73.7298 10.5493 79.5825 15.59 84.45C26.02 94.88 38.53 100.1 53.22 100.04C66.2754 100.3 78.9289 95.5187 88.55 86.69L13.41 11.54Z" />
            </svg>
          </Box>
        </Box>

        <Box css={{ width: '100%', padding: '$space$3', flexDirection: 'column' }}>
          <Text as="h6" css={{ textAlign: 'center' }}>
            Maintenance
          </Text>

          <Box css={{ width: '100%', flexDirection: 'column', maxHeight: 150, overflow: 'hidden auto' }}>
            <Text css={{ color: '$secondaryFill', fontSize: 14, textAlign: 'center' }}>
              Versum is currently unavailable. Please check our announcements channel on Discord for more information.
            </Text>
          </Box>
        </Box>

        <Box css={{ padding: '$space$3' }} vertical horizontal>
          <Button
            as="a"
            href="https://discord.gg/versum"
            target="_blank"
            rel="noopener noreferrer"
            full
            css={{ textAlign: 'center' }}
          >
            Discord
          </Button>
        </Box>
      </>
    </AlertDialog>
  );
};
